import defaultConfig from '@crema/constants/defaultConfig';
import PropTypes from 'prop-types';
import {
    createContext,
    useCallback,
    useContext,
    useMemo,
    useState,
} from 'react';

const SidebarContext = createContext();
const SidebarActionsContext = createContext();

export const useSidebarContext = () => useContext(SidebarContext);

export const useSidebarActionsContext = () => useContext(SidebarActionsContext);

const SidebarContextProvider = ({ children }) => {
    const [menuStyle, setMenuStyle] = useState(defaultConfig.sidebar.menuStyle);
    const [sidebarColorSet, setSidebarColorSet] = useState(
        defaultConfig.sidebar.colorSet,
    );
    const [allowSidebarBgImage, setAllowSidebarBgImage] = useState(
        defaultConfig.sidebar.allowSidebarBgImage,
    );
    const [sidebarBgImageId, setSidebarBgImageId] = useState(
        defaultConfig.sidebar.sidebarBgImageId,
    );

    const setSidebarBgImage = useCallback((allowSidebarBgImage) => {
        setAllowSidebarBgImage(allowSidebarBgImage);
    }, []);

    const updateSidebarBgImage = useCallback((sidebarBgImageId) => {
        setSidebarBgImageId(sidebarBgImageId);
    }, []);

    const values = useMemo(
        () => ({
            ...sidebarColorSet,
            menuStyle,
            allowSidebarBgImage,
            sidebarBgImageId,
            borderColor: defaultConfig.sidebar.borderColor,
        }),
        [sidebarColorSet, menuStyle, allowSidebarBgImage, sidebarBgImageId],
    );

    const actions = useMemo(
        () => ({
            setMenuStyle,
            setSidebarColorSet,
            setSidebarBgImage,
            updateSidebarBgImage,
        }),
        [
            setMenuStyle,
            setSidebarColorSet,
            setSidebarBgImage,
            updateSidebarBgImage,
        ],
    );

    return (
        <SidebarContext.Provider value={values}>
            <SidebarActionsContext.Provider value={actions}>
                {children}
            </SidebarActionsContext.Provider>
        </SidebarContext.Provider>
    );
};

export default SidebarContextProvider;

SidebarContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
